import React from 'react';
import { filterOffers } from 'src/components/price-list/filtering';
import { getAllOffersAsArray } from 'src/components/price-list/sorting';
import { useOfferListFilterContext } from '../offer-list-filter-context';
import ProductConditions from '../product-conditions';
import { Variants } from '../product-variants';
import { Category, ProductPageQuery } from 'src/types';
import { FiltersWrapper } from './styles';

const CATEGORY_SHOES = '1490';

export const ProductFilters: React.FC<IProductFilters> = props => {
  const { category, product } = props;
  const { getAdditiveFilters } = useOfferListFilterContext();
  const activeAdditiveFilters = getAdditiveFilters().filter(f => f.active);
  const priceListStatistics = product?.prices?.priceListStatistics;
  const showConditions = Boolean((priceListStatistics?.used ?? 0) > 0);
  const isInShoeCategory =
    category?.path?.length &&
    category?.path?.length >= 1 &&
    category.path[1]?.id === CATEGORY_SHOES;
  const hasShoeSizeVariants = isInShoeCategory;

  // For the variant values calculation (the options in the variant dialog)
  // we use all values that can be found in initial offerlist + any offers added by the addative filters
  const filteredOffers = filterOffers(
    getAllOffersAsArray(product?.prices),
    activeAdditiveFilters
  );

  return showConditions || hasShoeSizeVariants ? (
    <FiltersWrapper>
      {showConditions && (
        <ProductConditions priceListStatistics={priceListStatistics} />
      )}
      {hasShoeSizeVariants && <Variants offers={filteredOffers} />}
    </FiltersWrapper>
  ) : null;
};

interface IProductFilters {
  category?: Category | null;
  product: ProductPageQuery['product'];
}
